import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext';
import BackLoader from '../components/backloader';
import JisButton from '../components/controls/jisButton';
import CaseSearch from '../components/core/case_search';
import JisEmptyList from '../components/controls/emptylist';
import Pagenated from '../components/pagenated';
import CaseDetails from '../components/core/caseDetails';
import JisDialog from '../components/dialog';
import JisYesNo from '../components/controls/jisYesNo';
import JisDialogForm from '../components/formdialog';
import DeadlineBadge from '../components/controls/deadlinebadge';
import JisTabButton from '../components/controls/jisTabButton';

function Screeners() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState({});
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);
    const [isLiti, setIsLitiation]=useState(null);
    const [openOption, setOpenOption] = useState(false);
    const [comment, setComment] =useState('');
    const [option, setOption]=useState({});
    const [suitNumber, setSuitnumber]=useState('');
 const [tab, setTab] = useState('pending');

     useEffect(() => {
           if(pageIndex>=0){
             if(search!=null){
               onSearch(search);
             }
           }else{
             setPageIndex(0);
           }
                     
         }, [pageIndex,pageSize,search,tab]);

  const onSearch=async(sear)=>{ 
            
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/screeners/${tab}/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoad= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/screeners/${pageIndex}/${pageSize}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setCases(data.items)
               if(pageIndex==0){
                setCount(data.totalCount)
               }
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
 
      const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

    const onContinue=(fee,ind)=>{
        //navigate(`/case-details/${caseid}`)
        setActive(fee);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }
    const onAdrLitigation=(fee,ind)=>{
        //can load the option for filing type and display
        setActive(fee);
        setIndex(ind);
        setOpenOption(true);
        setOption({caseId:fee.caseId, divisionId: fee.divisionId});
        setSuitnumber('');
    }



   const onSave=async(e)=>{
             e.preventDefault();
             if(isLiti==null){
               setErr('Please select the ADR/Litigation option');
               return;
             }
             if(isLiti==false && suitNumber==''){
               setErr('Please generate Suit Number to Preview first');
               return;
             }
             setErr('');
              var approve={...option,isLitigation:isLiti,suitNumber:suitNumber,source:'screener'};
                
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/adr-litigation-approval`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setOpenOption(false)
                const ft=cases.filter((_, i) => i !== index)
                setCases(ft );
                if(isLiti==false){
                     setAlert({open:true, title:'ADR Option', subtitle:'Case moved to ADR successfully'});
                }else{
                    setAlert({open:true, title:'ADR Option', subtitle:'Litigation option set successfully'});
                }
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 
   const onGenerateNumber=async(e)=>{
             e.preventDefault();
             if(isLiti==null){
               setErr('Please select the ADR/Litigation option');
               return;
             }
             if(option.divisionId=='' || option.subCategoryId=='' || option.caseCategoryId==''){
               setErr('Please select from the options of Classification and sub Classification');
               return;
             }
             setErr('');
              var approve={...option,isLitigation:isLiti,source:'screener'};
                
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/generate-suit-number`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setSuitnumber(data.suit);
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       }    
const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}


const onDirectSearch=(sear)=>{
   setSearch(sear)       ;
   setIsSearch(true);
  setPageIndex(0);
}
 const onChangeTab=(t)=>{
      setTab(t);
      setPageIndex(0);
    }
  return (
    <div>
     
      <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} />

      <div className='tab_body'>
      <div className='tab_section'>
        <JisTabButton isActive={tab=='pending'}   title="Pending" 
       isRoleBased={false} onClick={()=> onChangeTab('pending')}/>

    {/*    <JisTabButton isActive={tab=='reject'}   title="Rejected Cases" 
       isRoleBased={false} onClick={()=> setTab('reject')}/> */}

        <JisTabButton isActive={tab=='rework'}   title="Rework Cases" 
       isRoleBased={false} onClick={()=> onChangeTab('rework')}/>

      <JisTabButton isActive={tab=='processed'}   title="Processed Cases" 
       isRoleBased={false} onClick={()=> onChangeTab('processed')}/>
       
      </div>
      <div className='tab_view'>

      </div>
    </div>
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases">
  <span>Screener Cases </span><span className='total'>{count}</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Date Filed</th>
      <th>Status Level</th>
      <th>SLA</th>
      <th>Details</th>
      
      {tab!="processed" && <th>ADR/Litigation</th>}
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => {
      const cc=Constants.getSlaTimeLeft(opt.slaExpire);
      return <tr key={index} >
      <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}>{opt.referenceNumber}</td>
      <td>{opt.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
       <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
         <td> <DeadlineBadge dateString={opt.slaExpire} /></td>
   
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
      {tab!="processed" &&  <td><JisButton variant='plain' onClick={()=>onAdrLitigation(opt,index)}>ADR/Litigation</JisButton></td>}
     
    </tr>
    })} 
    


  </tbody>
</table>
{cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div>}
<BackLoader open={loading} />


  {openCase && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
          </div>
</JisDialogForm>}         
      {openOption && <JisDialogForm title="Litigation/ADR Option" onClose={()=> setOpenOption(false)}>
                    <form onSubmit={onSave}>
                        <div>
                            <JisYesNo  label= {`This case ( ${active?.referenceNumber}) is suitable for`} value={isLiti} yes="Litigation" no="ADR"  onChange={(e)=>setIsLitiation(e) }/> 
                 {isLiti==false && <div>
                         <div className="select-group">
                          <label>
                              Division  
                          </label>
                          <select name="divisionId" value={option.divisionId}  onChange={onOptionChange} required>
                              <option value="">Select </option>
                              {frequentData.divisions?.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.title}
                              </option>
                              ))}
                          </select>
                          
                      </div>
                      <div className="select-group">
                          <label>
                             Classification:  
                          </label>
                          <select name="caseCategoryId" value={option.caseCategoryId}  onChange={onOptionChange} required>
                              <option value="">Select Classification </option>
                             <option value='0'>Alternative Dispute Resolution</option>
                          </select>
                          
                      </div>
                      <div className="select-group">
                          <label>
                              Sub-Classification:  
                          </label>
                          <select name="subCategoryId" value={option.subCategoryId}  onChange={onOptionChange} required>
                              <option value="">Select Sub-Classification </option>
                             <option value='0'>ADR</option>
                          </select>
                          
                      </div>
                 </div>} 
                            <div  className="input-group">
                                <label>Comment <span className="required">*</span> </label>
                                <div className='input-wrapper'>
                                    <DynamicIcon iname="group" />
                                    <textarea placeholder=' Comment' name='comment' required={true}  value={option.comment}
                            onChange={onOptionChange }  />
                                </div>
                            </div> 
                            {err!="" && <div className='error'>{err}</div>}
                       {isLiti==false &&  <div style ={{marginBottom:16}}><JisButton type="button" onClick={onGenerateNumber}>Generate Suit Number </JisButton>  </div>}
                           {suitNumber!='' && <div style={{fontSize:16}}> <strong>{suitNumber}</strong>  Will be your permanent suit number</div>} 
                           
                            {(suitNumber!='' || isLiti==true) && <>
                            <JisButton type="submit">Save </JisButton>  
                            <JisButton type="button" onClick={()=> setOpenOption(false)}>Cancel </JisButton>             
                           </>}             
                        </div>
                    </form>
            </JisDialogForm>}    
    </div>
  );
}

export default Screeners;